import { lazy, Suspense } from 'react';
import IndicatorPageLoader from 'navigation/loaders/Indicator';

const Page = lazy(() => import('./component'));

export default function UserPageLoader() {
  return (
    <Suspense fallback={<IndicatorPageLoader fullPage />}>
      <Page />
    </Suspense>
  );
}
